// src/plugins/device.js
import { isIOS } from '@/composables/deviceShared'

export default {
  install(app) {
    app.provide('isIOS', isIOS)
  }
}
